/**
 * Determine whether an object is a graph reference
 * @param {*} value The object to test
 * @return {boolean} Whether the object is a graph reference
 */
function isRef(value) {
  return Boolean(value) && (value.$type === 'ref');
}

module.exports = isRef;
